import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid2 as Grid,
  Button,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ExternalLink } from "../../components/ExternalLink";
import { PaymentDetailsModel } from "@attelas/shared";
import { formatAmount } from "../../utils/formatAmount";
import { formatDate } from "../../utils/formatDate";
import { StyledTable } from "./styled";

type Props = {
  receipts: PaymentDetailsModel[];
  customerLink?: string;
};

export function Receipts({ receipts, customerLink }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Accordion defaultExpanded disableGutters>
      <AccordionSummary
        expandIcon={<KeyboardArrowDownIcon />}
        aria-controls="receipts-panel-content"
        id="receipts-panel"
      >
        <Typography variant="h3">Receipts</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer>
          <StyledTable size="small" aria-label="receipt table">
            <TableHead>
              <TableRow>
                <TableCell>Receipt</TableCell>
                <TableCell align="right">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {receipts.map((receipt) => (
                <TableRow key={receipt.id}>
                  <TableCell>
                    <ExternalLink href={receipt.link}>Receipt</ExternalLink>
                    <Typography>{formatAmount(-Math.abs(receipt.amount))}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{formatDate(receipt.date, { day: "numeric", month: "short" })}</Typography>
                    <Typography>{receipt.accountName}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>
        <Grid
          container
          justifyContent="center"
          sx={{ pt: 0.5, backgroundColor: isDarkMode ? "common.black" : "common.white" }}
        >
          <Button variant="text" size="small" href={customerLink ?? ""} target="_blank" endIcon={<OpenInNewIcon />}>
            More details
          </Button>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
